import { Box, Typography } from '@mui/material';
import React from 'react';
import { ColorPalette } from '../config/color-palette';
import { TypographySettings } from '../config/typography-settings';
import { IPageTitleZoneProps } from './page-title-zone-props';

export function PageTitleZoneNext(props: IPageTitleZoneProps) {
  const { entityName, title, subtitle, isSocialProviderContext } = props;

  return (
    <Box
      sx={{
        backgroundColor: isSocialProviderContext ? ColorPalette.SocialProviderGreen : ColorPalette.ScrubsGreen,
        color: ColorPalette.DefaultTextColor,
        fontFamily: TypographySettings.DefaultFontFamily,
        padding: 2,
      }}
    >
      {entityName && (
        <Typography sx={{ fontSize: '14px', padding: 0, marginBottom: '5px', lineHeight: 1 }} variant="body1" component="div">
          {entityName}
        </Typography>
      )}
      <Box display="flex">
        {title && (
          <Typography sx={{ fontWeight: 600, padding: 0, lineHeight: 1, fontSize: '1.2rem', paddingRight: '5px' }} variant="body1" component="div">
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography sx={{ fontWeight: 400, padding: 0, lineHeight: 1, fontSize: '1.2rem' }} variant="body1" component="div">
            {`${title ? '- ' : ''}`}
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
